var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNextVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 4C13.6716 4 13 4.67157 13 5.5V14.5C13 15.3284 13.6716 16 14.5 16C15.3284 16 16 15.3284 16 14.5V5.5C16 4.67157 15.3284 4 14.5 4ZM4.96683 4.37678L11.2445 8.77115C12.0976 9.3683 12.0976 10.6317 11.2445 11.2288L4.96683 15.6232C4.13836 16.2031 3 15.6105 3 14.5992V5.40082C3 4.38954 4.13836 3.79685 4.96683 4.37678Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNextVideo);
export default __webpack_public_path__ + "static/media/icon-next-video.ad156f9832c2e297177c8cca46fd8249.svg";
export { ForwardRef as ReactComponent };